import { Box, Checkbox, ListItemText, MenuItem, Modal } from "@mui/material";
import { SelectVersionModalContainer } from "../../pages/MyTracks/styles";
import CloseIcon from "@mui/icons-material/Close";
import { SelectVersionModalProps } from "./types";
import { styles } from "./styles";

export const SelectVersionModal: React.FC<SelectVersionModalProps> = ({
  isSelectVersionModalOpen,
  setIsSelectVersionModalOpen,
  versions,
  setChangeVersionLoading,
  handleChange,
  selectedTrackVersionLabel,
}) => {
  return (
    <>
      <Modal
        open={isSelectVersionModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <SelectVersionModalContainer>
          <Box
            onClick={() => {
              setIsSelectVersionModalOpen(false);
            }}
            sx={styles.closeIconContainer}
          >
            <CloseIcon />
          </Box>
          {versions &&
            versions.map((el) => {
              return (
                <MenuItem
                  onClick={() => {
                    if (el.track?.getLabel()) {
                      setChangeVersionLoading(true);
                      handleChange(el.track.getTimestamp());
                    }
                  }}
                  key={el.track?.getId()}
                  value={el.track?.getLabel()}
                  style={{ margin: "10px", cursor: "pointer" }}
                >
                  <Checkbox
                    checked={el.track?.getLabel() === selectedTrackVersionLabel}
                  />
                  <ListItemText primary={el.track?.getLabel()} />
                </MenuItem>
              );
            })}
        </SelectVersionModalContainer>
      </Modal>
    </>
  );
};
